export default function ElectricOven(props: any) {
    return (
        <svg width="38" height="39" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="Electric Oven_icon" clipPath="url(#clip0_94_5524)">
                <g id="&#231;&#188;&#150;&#231;&#187;&#132;-90">
                    <path
                        id="Stroke-245"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M30.3519 36.1374H7.64879C6.59895 36.1374 5.74805 35.2241 5.74805 34.0973V4.70139C5.74805 3.57462 6.59895 2.66138 7.64879 2.66138H30.3519C31.4017 2.66138 32.2526 3.57462 32.2526 4.70139V34.0973C32.2526 35.2241 31.4017 36.1374 30.3519 36.1374Z"
                        stroke="black"
                        strokeWidth="1.3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path id="Stroke-250" d="M5.74756 10.3622H32.2522" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                        id="Stroke-246"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M27.4708 31.373H10.5289C9.82941 31.373 9.26172 30.7644 9.26172 30.013V18.4312C9.26172 17.6798 9.82941 17.0712 10.5289 17.0712H27.4708C28.1703 17.0712 28.738 17.6798 28.738 18.4312V30.013C28.738 30.7644 28.1703 31.373 27.4708 31.373Z"
                        stroke="black"
                        strokeWidth="1.3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <g id="Group 161268623">
                        <path
                            id="Stroke-247"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M15.8105 7.48299H22.6018V5.38318H15.8105V7.48299Z"
                            stroke="black"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            id="Stroke-248"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12.7573 6.43311C12.7573 7.1233 12.1975 7.68311 11.5073 7.68311C10.8166 7.68311 10.2573 7.1233 10.2573 6.43311C10.2573 5.74291 10.8166 5.18311 11.5073 5.18311C12.1975 5.18311 12.7573 5.74291 12.7573 6.43311Z"
                            stroke="black"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            id="Stroke-249"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M27.7427 6.43311C27.7427 7.1233 27.1829 7.68311 26.4927 7.68311C25.8019 7.68311 25.2427 7.1233 25.2427 6.43311C25.2427 5.74291 25.8019 5.18311 26.4927 5.18311C27.1829 5.18311 27.7427 5.74291 27.7427 6.43311Z"
                            stroke="black"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <path id="Stroke-251" d="M9.2373 13.714H28.7136" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                        id="Stroke-252"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.25293 36.6614H11.3032V36.1371H9.25293V36.6614Z"
                        stroke="black"
                        strokeWidth="1.3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Stroke-253"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M26.6968 36.6614H28.747V36.1371H26.6968V36.6614Z"
                        stroke="black"
                        strokeWidth="1.3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_94_5524">
                    <rect width="38" height="38" fill="white" transform="translate(0 0.661377)" />
                </clipPath>
            </defs>
        </svg>
    );
}
